import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-layout" }
const _hoisted_2 = { class: "content" }

import { watch } from 'vue';
import { useRoute } from 'vue-router';
import AppSidebar from '@/components/layout/AppSidebar.vue';
import AppFooter from '@/components/layout/AppFooter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageLayout',
  setup(__props) {

const route = useRoute();

watch(
  () => route.path,
  () => {
    document.querySelector<HTMLElement>('.content')?.scrollTo({ top: 0 });
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppSidebar),
    _createElementVNode("main", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(AppFooter)
    ])
  ]))
}
}

})